import { TQuestionDifficulty } from '../store/QuestionSlice';

export interface ISelectedOption {
  label: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ISelectedDataOption {
  selectedItem: ISelectedOption;
  options: ISelectedOption[];
}

export const allSelectedOption: ISelectedOption = {
  label: 'All',
  value: 'All',
};

export const defaultEmptySelectedOption: ISelectedOption = {
  label: '',
  value: '',
};

export const defaultSelectedDataOption: ISelectedDataOption = {
  selectedItem: defaultEmptySelectedOption,
  options: [],
};

export const questionDifficultyOptions: Array<TQuestionDifficulty> = [
  'EASY',
  'MEDIUM',
  'HARD',
];
